const BASE_URL =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://api.pople.kr/api/v1/'
    : 'https://api-dev.pople.kr/api/v1/';

export { BASE_URL };
